var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSong(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-music"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3379_13894",
    maskUnits: "userSpaceOnUse",
    x: 10.8333,
    y: 2.75,
    width: 7,
    height: 7,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 10.8333,
    y: 2.75,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8333 2.75V6.41667C12.8333 6.92293 13.2437 7.33333 13.7499 7.33333H17.4166"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.75V6.41667H14.3333V2.75H11.3333ZM11.3333 6.41667C11.3333 7.75135 12.4152 8.83333 13.7499 8.83333V5.83333C14.0721 5.83333 14.3333 6.0945 14.3333 6.41667H11.3333ZM13.7499 8.83333H17.4166V5.83333H13.7499V8.83333Z",
    fill: "#2F2B3D",
    fillOpacity: 0.9,
    mask: "url(#path-1-outside-1_3379_13894)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M13.3636 2.21967L13.1439 2H12.8333H6.41659C4.98985 2 3.83325 3.1566 3.83325 4.58333V17.4167C3.83325 18.8434 4.98985 20 6.41659 20H15.5833C17.01 20 18.1666 18.8434 18.1666 17.4167V7.33333V7.02267L17.9469 6.803L13.3636 2.21967Z",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 10.0834,
    cy: 14.6667,
    r: 0.916667,
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M11 14.6668V10.0835L12.8333 11.0002",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSong);
export default __webpack_public_path__ + "static/media/song.771f1fc188714cb9ebcb6d77fb2f3513.svg";
export { ForwardRef as ReactComponent };